import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'tutorial',
    loadChildren: () =>
      import('./tutorial/tutorial.module').then((m) => m.TutorialModule),
  },
  {
    path: 'rules',
    loadChildren: () =>
      import('./rules/rules.module').then((m) => m.RulesModule),
  },
  {
    path: 'debug',
    loadChildren: () =>
      import('./debug/debug.module').then((m) => m.DebugModule),
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./about/about.module').then((m) => m.AboutModule),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/rules',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
